import { md5, on, off, timestamp } from '@roai/shared';

interface ICoordinate {
  x: number;
  y: number;
}

const MAX_COORDINATE_LENGTH = 49;
export default class MouseBehavior {
  private isRunning: boolean = false;
  private initTime: Nullable<number> = null;
  private downTime: Nullable<number> = null;
  private upTime: Nullable<number> = null;
  private trail: number[][] = [];
  private moveInfo: string = '';
  private lastMoveTime: Nullable<number> = null; 
  private firstCoord: ICoordinate = {
    x: 0,
    y: 0,
  };
  private index: number = 1;

  constructor() {
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);
    this.handleMouseDown = this.handleMouseDown.bind(this);
  }

  private handleMouseMove(e: MouseEvent) {
    const now = timestamp();
    if (!this.initTime) {
      this.initTime = now;
    }

    const coord = this.getCoordinate(e);
    if (!this.lastMoveTime) {
      this.firstCoord = coord;
      this.lastMoveTime = now;
      return;
    }

    const gapTime = now - this.lastMoveTime;
    this.lastMoveTime = now;

    // 最多收集 50 组
    if (this.trail.length < MAX_COORDINATE_LENGTH) {
      this.trail.push([this.index, coord.x, coord.y, gapTime]);
      this.index = this.index + 1;
    }
  }

  private handleMouseDown() {
    this.downTime = timestamp();
  }

  private handleMouseUp(e: MouseEvent) {
    this.upTime = timestamp();

    const pos = this.getCoordinate(e);
    // 鼠标移动的次数
    const x = this.trail.length + 1;
    // 鼠标按下和放开的时间间隔
    const y = this.downTime ? this.upTime - this.downTime : 0;
    // 鼠标进入到点击的时间间隔
    const z = this.initTime ? this.upTime - this.initTime : 0;

    // 鼠标点击的坐标
    const a = pos.x;
    const b = pos.y;

    // 第一次鼠标移动的坐标
    const c = this.firstCoord.x;
    const d = this.firstCoord.y;
    
    // 安全地处理 trail 数组
    const t = this.trail[0] || [];
    const trailSum = t.reduce((sum, val) => sum + val, 0);
    const s = md5(x + y + z + a + b + c + d + trailSum);
    const prefix = `${s},${x},${y},${z}|${a},${b}|${c},${d}|`;

    this.moveInfo = prefix + this.trail.join('|');

    this.trail = [];
    this.index = 1;
  }

  public start() {
    if (this.isRunning) return;
    this.isRunning = true;

    const now = timestamp();
    this.downTime = now;
    this.upTime = now;

    on(document, 'mousemove', this.handleMouseMove);
    on(document, 'mousedown', this.handleMouseMove);
    on(document, 'mouseup', this.handleMouseUp);
  }

  public getMoveInfo(): string {
    return this.moveInfo || '';
  }

  public stop() {
    this.isRunning = false;
    this.trail = [];
    this.downTime = null;
    this.upTime = null;
    this.initTime = null;
    this.lastMoveTime = null;
    this.moveInfo = '';
    this.index = 1;

    off(document, 'mousedown', this.handleMouseDown);
    off(document, 'mousemove', this.handleMouseMove);
    off(document, 'mouseup', this.handleMouseUp);
  }

  private getCoordinate(event: MouseEvent): ICoordinate {
    if (event.pageX || event.pageY) {
      return {
        x: event.pageX,
        y: event.pageY,
      }
    }

    return {
      x: event.clientX + document.body.scrollLeft - document.body.clientLeft,
      y: event.clientY + document.body.scrollTop - document.body.clientTop,
    }
  }
}
